import React, { useState } from 'react';
import LoadingSpinnerImage from "../Shared/LoadingSpinnerImage.js";

const AddItemPopup = ({ globalContext }) => {

    const AppContext = globalContext;
    const [name, setName] = useState("");
    const [description, setDescription] = useState("");
    const [alertsEnabled, setAlertsEnabled] = useState(false);
    const [errorName, setErrorName] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [isAddingItem, setIsAddingItem] = useState(false);

    const addItem = () => {
        setErrorMessage(null);
        setErrorName(false);

        if (!name || name.trim() === "") {
            setErrorName(true);
            return;
        }

        const formData = new FormData();
        formData.append("Name", name.trim());
        formData.append("Description", description || "");
        formData.append("AlertsEnabled", alertsEnabled ? "true" : "false");

        setIsAddingItem(true);

        fetch(AppContext.dataUrl, { method: "POST", body: formData })
            .then(async (response) => {
                if (!response.ok) {
                    let message = await response.text();
                    throw new Error(message || "Unexpected error, refresh and try again");
                }
                return response.json();
            })
            .then((item) => {
                AppContext.setData([item, ...AppContext.data]);
                if (AppContext.updateListTotalCount)
                    AppContext.updateListTotalCount();
                AppContext.showAddItemPopup(false);
                setName("");
                setDescription("");
                setAlertsEnabled(false);
            })
            .catch((error) => {
                setErrorMessage(error.message);
            })
            .finally(() => {
                setIsAddingItem(false);
            });
    };

    return (
        <div className="add-task-popup">
            <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ width: "50%" }}>
                    <h3>Add {AppContext.singleItemTitle}</h3>
                </div>
                <div style={{ width: "50%", textAlign: "right" }}>
                    <button className="close-button" onClick={() => AppContext.showAddItemPopup(false)}>
                        <i className="fas fa-times"></i>
                    </button>
                </div>
            </div>

            <div style={{ marginTop: "20px" }}>
                <div style={{ marginBottom: "14px" }}>
                    <label style={{ display: "block", fontWeight: 600, marginBottom: "6px" }}>Name *</label>
                    <input type="text" value={name} onChange={(e) => setName(e.target.value)} style={{ width: "100%", border: errorName ? "1px solid #e53e3e" : "1px solid #ccc", padding: "6px 8px" }} />
                    {errorName && <div style={{ color: "#e53e3e", fontSize: "12px", marginTop: "4px" }}>Name is required</div>}
                </div>
                <div style={{ marginBottom: "14px" }}>
                    <label style={{ display: "block", fontWeight: 600, marginBottom: "6px" }}>Description</label>
                    <textarea rows={4} value={description} onChange={(e) => setDescription(e.target.value)} style={{ width: "100%", border: "1px solid #ccc", padding: "6px 8px" }} />
                </div>
                <div style={{ marginBottom: "14px" }}>
                    <label style={{ display: "block", fontWeight: 600, marginBottom: "6px" }}>Alerts</label>
                    <div className="watchlists-alerts-bell-row">
                        <button
                            type="button"
                            className={`watchlists-alerts-bell ${alertsEnabled ? "enabled" : "disabled"}`}
                            title={alertsEnabled ? "Click to turn OFF alerts" : "Click to turn ON alerts"}
                            onClick={() => setAlertsEnabled(!alertsEnabled)}
                        >
                            <i className={`fas ${alertsEnabled ? "fa-bell" : "fa-bell-slash"}`} />
                        </button>
                        <span className={`watchlists-alerts-status ${alertsEnabled ? "enabled" : "disabled"}`}>
                            {alertsEnabled ? "Alerts enabled" : "Alerts disabled"}
                        </span>
                    </div>
                    <div style={{ marginTop: "6px", fontSize: "12px", color: "#718096" }}>
                        You can choose which company users receive alerts after creating the watchlist.
                    </div>
                </div>
                {errorMessage && <div style={{ color: "#e53e3e", marginBottom: "12px" }}>{errorMessage}</div>}
                <div style={{ textAlign: "right" }}>
                    <button type="button" className="btn btn-primary" onClick={addItem} disabled={isAddingItem}>
                        {isAddingItem ? <LoadingSpinnerImage /> : "Create"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AddItemPopup;
